"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIncrementDecrement = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useIncrementDecrement = ({ defaultValue, disabled = false, }) => {
    const [selectedQty, setSelectedQty] = (0, react_1.useState)(defaultValue ?? 1);
    const decrement = () => {
        if (!disabled) {
            setSelectedQty((prevQty) => (prevQty > 1 ? prevQty - 1 : 1));
        }
    };
    const increment = () => {
        if (!disabled) {
            setSelectedQty((prevQty) => prevQty + 1);
        }
    };
    const IncrementDecrement = () => {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-center", children: [(0, jsx_runtime_1.jsx)("button", { className: `h-12 w-12 rounded-l-lg border ${disabled
                        ? 'cursor-not-allowed bg-gray-300'
                        : 'bg-white active:bg-gray-100'}`, onClick: decrement, disabled: disabled, children: "-" }), (0, jsx_runtime_1.jsx)("div", { className: "flex h-12 w-12 items-center justify-center border-y", children: (0, jsx_runtime_1.jsx)("input", { className: "h-12 w-12 border-y text-center !outline-none", pattern: "\\d*", onChange: (e) => {
                            if (!isNaN(e.target.value) && !disabled) {
                                setSelectedQty(parseInt(e.target.value));
                            }
                        }, value: isNaN(selectedQty) ? 0 : selectedQty, disabled: disabled }) }), (0, jsx_runtime_1.jsx)("button", { onClick: increment, className: `h-12 w-12 rounded-r-lg border ${disabled
                        ? 'cursor-not-allowed bg-gray-300'
                        : 'bg-white active:bg-gray-100'}`, disabled: disabled, children: "+" })] }));
    };
    return {
        IncrementDecrement,
        selectedQty,
    };
};
exports.useIncrementDecrement = useIncrementDecrement;
